module.exports = __webpack_public_path__ + "media/application/images/icons/download-d7e14cae15c5e05f563e7bda543d26cb.svg";